"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BreadcrumbListItem = _interopRequireDefault(require("./BreadcrumbListItem"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var BreadcrumbList = props => {
  return /*#__PURE__*/_react.default.createElement("ol", {
    className: "breadcrumb"
  }, props.breadcrumbs.map((crumb, index) => /*#__PURE__*/_react.default.createElement(_BreadcrumbListItem.default, {
    key: index,
    crumb: crumb,
    isLastItem: index === props.breadcrumbs.length - 1,
    breadcrumbTrimPlaceholder: props.breadcrumbTrimPlaceholder
  })));
};
var _default = exports.default = BreadcrumbList;